/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   vssf\client\webapi\httpclients\clientgeneratorconfigs\graph.genclient.json
 */

"use strict";

import Contracts = require("VSS/Graph/Contracts");
import VSS_Common_Contracts = require("VSS/WebApi/Contracts");
import VSS_Profile_Contracts = require("VSS/Profile/Contracts");
import VSS_Service = require("VSS/Service");
import VSS_WebApi = require("VSS/WebApi/RestClient");

export class CommonMethods3_1To7_2 extends VSS_WebApi.VssHttpClient {
    protected descriptorsApiVersion: string;

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }

    /**
     * Resolve a storage key to a descriptor
     *
     * @param {string} storageKey - Storage key of the subject (user, group, scope, etc.) to resolve
     * @return IPromise<Contracts.GraphDescriptorResult>
     */
    public getDescriptor(
        storageKey: string
        ): IPromise<Contracts.GraphDescriptorResult> {

        return this._beginRequest<Contracts.GraphDescriptorResult>({
            httpMethod: "GET",
            area: "Graph",
            locationId: "048aee0a-7072-4cde-ab73-7af77b1e0b4e",
            resource: "Descriptors",
            routeTemplate: "_apis/{area}/{resource}/{storageKey}",
            routeValues: {
                storageKey: storageKey
            },
            apiVersion: this.descriptorsApiVersion
        });
    }
}

export class CommonMethods3_2To7_2 extends CommonMethods3_1To7_2 {
    protected cachePoliciesApiVersion: string;
    protected groupsApiVersion: string;
    protected memberLookupApiVersion: string;
    protected membersApiVersion: string;
    protected membershipsApiVersion: string;
    protected membershipsBatchApiVersion: string;
    protected membershipStatesApiVersion: string;
    protected membershipTraversalsApiVersion: string;
    protected scopesApiVersion: string;
    protected storageKeysApiVersion: string;
    protected subjectLookupApiVersion: string;
    protected subjectsApiVersion: string;
    protected usersApiVersion: string;

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }

    /**
     * @exemptedapi
     * [Preview API] Map an existing user to a different user.
     *
     * @param {Contracts.GraphUserUpdateContext} updateContext - The subset of the full graph user used to uniquely find the graph subject in an external provider.
     * @param {string} userDescriptor - The descriptor of the user to update
     * @return IPromise<Contracts.GraphUser>
     */
    public updateUser(
        updateContext: Contracts.GraphUserUpdateContext,
        userDescriptor: string
        ): IPromise<Contracts.GraphUser> {

        return this._beginRequest<Contracts.GraphUser>({
            httpMethod: "PATCH",
            area: "Graph",
            locationId: "005e26ec-6b77-4e4f-a986-b3827bf241f5",
            resource: "Users",
            routeTemplate: "_apis/{area}/{resource}/{userDescriptor}",
            responseType: Contracts.TypeInfo.GraphUser,
            routeValues: {
                userDescriptor: userDescriptor
            },
            apiVersion: this.usersApiVersion,
            data: updateContext
        });
    }

    /**
     * @exemptedapi
     * [Preview API] Get a list of all users in a given scope.
     *
     * @param {string[]} subjectTypes - A comma separated list of user subject subtypes to reduce the retrieved results, e.g. msa’, ‘aad’, ‘svc’ (service identity), ‘imp’ (imported identity), etc.
     * @param {string} continuationToken - An opaque data blob that allows the next page of data to resume immediately after where the previous page ended. The only reliable way to know if there is more data left is the presence of a continuation token.
     * @param {string} scopeDescriptor - Specify a non-default scope (collection, project) to search for users.
     * @return IPromise<Contracts.PagedGraphUsers>
     */
    public listUsers(
        subjectTypes?: string[],
        continuationToken?: string,
        scopeDescriptor?: string
        ): IPromise<Contracts.PagedGraphUsers> {

        const queryValues: any = {
            subjectTypes: subjectTypes && subjectTypes.join(","),
            continuationToken: continuationToken,
            scopeDescriptor: scopeDescriptor
        };

        return this._beginRequest<[any, string, JQueryXHR]>({
            httpMethod: "GET",
            area: "Graph",
            locationId: "005e26ec-6b77-4e4f-a986-b3827bf241f5",
            resource: "Users",
            routeTemplate: "_apis/{area}/{resource}/{userDescriptor}",
            responseType: Contracts.TypeInfo.GraphUser,
            responseIsCollection: true,
            queryParams: queryValues,
            apiVersion: this.usersApiVersion
        }, true).then(([data, textStatus, jqXHR]) => {
            const continuationTokenHeader = jqXHR.getResponseHeader("X-MS-ContinuationToken");
            return {
                graphUsers: data,
                continuationToken: continuationTokenHeader ? continuationTokenHeader.split(',') : []
            };
        });
    }

    /**
     * @exemptedapi
     * [Preview API] Get a user by its descriptor.
     *
     * @param {string} userDescriptor - The descriptor of the desired user.
     * @return IPromise<Contracts.GraphUser>
     */
    public getUser(
        userDescriptor: string
        ): IPromise<Contracts.GraphUser> {

        return this._beginRequest<Contracts.GraphUser>({
            httpMethod: "GET",
            area: "Graph",
            locationId: "005e26ec-6b77-4e4f-a986-b3827bf241f5",
            resource: "Users",
            routeTemplate: "_apis/{area}/{resource}/{userDescriptor}",
            responseType: Contracts.TypeInfo.GraphUser,
            routeValues: {
                userDescriptor: userDescriptor
            },
            apiVersion: this.usersApiVersion
        });
    }

    /**
     * @exemptedapi
     * [Preview API] Disables a user.
     *
     * @param {string} userDescriptor - The descriptor of the user to delete.
     * @return IPromise<void>
     */
    public deleteUser(
        userDescriptor: string
        ): IPromise<void> {

        return this._beginRequest<void>({
            httpMethod: "DELETE",
            httpResponseType: "html",
            area: "Graph",
            locationId: "005e26ec-6b77-4e4f-a986-b3827bf241f5",
            resource: "Users",
            routeTemplate: "_apis/{area}/{resource}/{userDescriptor}",
            routeValues: {
                userDescriptor: userDescriptor
            },
            apiVersion: this.usersApiVersion
        });
    }

    /**
     * @exemptedapi
     * [Preview API] Materialize an existing AAD or MSA user into the ADO account.
     *
     * @param {Contracts.GraphUserCreationContext} creationContext - The subset of the full graph user used to uniquely find the graph subject in an external provider.
     * @param {string[]} groupDescriptors - A comma separated list of descriptors of groups you want the graph user to join
     * @return IPromise<Contracts.GraphUser>
     */
    public createUser(
        creationContext: Contracts.GraphUserCreationContext,
        groupDescriptors?: string[]
        ): IPromise<Contracts.GraphUser> {

        const queryValues: any = {
            groupDescriptors: groupDescriptors && groupDescriptors.join(",")
        };

        return this._beginRequest<Contracts.GraphUser>({
            httpMethod: "POST",
            area: "Graph",
            locationId: "005e26ec-6b77-4e4f-a986-b3827bf241f5",
            resource: "Users",
            routeTemplate: "_apis/{area}/{resource}/{userDescriptor}",
            responseType: Contracts.TypeInfo.GraphUser,
            queryParams: queryValues,
            apiVersion: this.usersApiVersion,
            data: creationContext
        });
    }

    /**
     * @internal
     * @exemptedapi
     * [Preview API] Resolve a descriptor to a user, group or scope.
     *
     * @param {string} subjectDescriptor - The descriptor of the desired subject.
     * @return IPromise<Contracts.GraphSubject>
     */
    public getSubject(
        subjectDescriptor: string
        ): IPromise<Contracts.GraphSubject> {

        return this._beginRequest<Contracts.GraphSubject>({
            httpMethod: "GET",
            area: "Graph",
            locationId: "1d44a2ac-4f8a-459e-83c2-1c92626fb9c6",
            resource: "Subjects",
            routeTemplate: "_apis/{area}/{resource}/{subjectDescriptor}",
            routeValues: {
                subjectDescriptor: subjectDescriptor
            },
            apiVersion: this.subjectsApiVersion
        });
    }

    /**
     * @exemptedapi
     * [Preview API] Resolve descriptors to users, groups or scopes (Subjects) in a batch.
     *
     * @param {Contracts.GraphSubjectLookup} subjectLookup - A list of descriptors that specifies a subset of subjects to retrieve. Each descriptor uniquely identifies the subject across all instance scopes, but only at a single point in time.
     * @return IPromise<{ [key: string] : Contracts.GraphSubject; }>
     */
    public lookupSubjects(
        subjectLookup: Contracts.GraphSubjectLookup
        ): IPromise<{ [key: string] : Contracts.GraphSubject; }> {

        return this._beginRequest<{ [key: string] : Contracts.GraphSubject; }>({
            httpMethod: "POST",
            area: "Graph",
            locationId: "4dd4d168-11f2-48c4-83e8-756fa0de027c",
            resource: "SubjectLookup",
            routeTemplate: "_apis/{area}/{resource}",
            responseIsCollection: true,
            apiVersion: this.subjectLookupApiVersion,
            data: subjectLookup
        });
    }

    /**
     * Resolve a descriptor to a storage key.
     *
     * @param {string} subjectDescriptor
     * @return IPromise<Contracts.GraphStorageKeyResult>
     */
    public getStorageKey(
        subjectDescriptor: string
        ): IPromise<Contracts.GraphStorageKeyResult> {

        return this._beginRequest<Contracts.GraphStorageKeyResult>({
            httpMethod: "GET",
            area: "Graph",
            locationId: "eb85f8cc-f0f6-4264-a5b1-ffe2e4d4801f",
            resource: "StorageKeys",
            routeTemplate: "_apis/{area}/{resource}/{subjectDescriptor}",
            routeValues: {
                subjectDescriptor: subjectDescriptor
            },
            apiVersion: this.storageKeysApiVersion
        });
    }

    /**
     * @internal
     * @exemptedapi
     * [Preview API]
     *
     * @param {string} scopeDescriptor
     * @param {VSS_Common_Contracts.JsonPatchDocument} patchDocument
     * @return IPromise<void>
     */
    public updateScope(
        scopeDescriptor: string,
        patchDocument: VSS_Common_Contracts.JsonPatchDocument
        ): IPromise<void> {

        return this._beginRequest<void>({
            httpMethod: "PATCH",
            httpResponseType: "html",
            area: "Graph",
            locationId: "21b5fea7-2513-41d0-af78-b8cdb0f328bb",
            resource: "Scopes",
            routeTemplate: "_apis/{area}/{resource}/{scopeDescriptor}",
            routeValues: {
                scopeDescriptor: scopeDescriptor
            },
            customHeaders: {
                "Content-Type": "application/json-patch+json",
            },
            apiVersion: this.scopesApiVersion,
            data: patchDocument
        });
    }

    /**
     * @internal
     * @exemptedapi
     * [Preview API] Get a scope identified by its descriptor
     *
     * @param {string} scopeDescriptor - A descriptor that uniquely identifies a scope.
     * @return IPromise<Contracts.GraphScope>
     */
    public getScope(
        scopeDescriptor: string
        ): IPromise<Contracts.GraphScope> {

        return this._beginRequest<Contracts.GraphScope>({
            httpMethod: "GET",
            area: "Graph",
            locationId: "21b5fea7-2513-41d0-af78-b8cdb0f328bb",
            resource: "Scopes",
            routeTemplate: "_apis/{area}/{resource}/{scopeDescriptor}",
            responseType: Contracts.TypeInfo.GraphScope,
            routeValues: {
                scopeDescriptor: scopeDescriptor
            },
            apiVersion: this.scopesApiVersion
        });
    }

    /**
     * @internal
     * @exemptedapi
     * [Preview API]
     *
     * @param {string} scopeDescriptor
     * @return IPromise<void>
     */
    public deleteScope(
        scopeDescriptor: string
        ): IPromise<void> {

        return this._beginRequest<void>({
            httpMethod: "DELETE",
            httpResponseType: "html",
            area: "Graph",
            locationId: "21b5fea7-2513-41d0-af78-b8cdb0f328bb",
            resource: "Scopes",
            routeTemplate: "_apis/{area}/{resource}/{scopeDescriptor}",
            routeValues: {
                scopeDescriptor: scopeDescriptor
            },
            apiVersion: this.scopesApiVersion
        });
    }

    /**
     * @internal
     * @exemptedapi
     * [Preview API]
     *
     * @param {Contracts.GraphScopeCreationContext} creationContext
     * @param {string} scopeDescriptor
     * @return IPromise<Contracts.GraphScope>
     */
    public createScope(
        creationContext: Contracts.GraphScopeCreationContext,
        scopeDescriptor?: string
        ): IPromise<Contracts.GraphScope> {

        return this._beginRequest<Contracts.GraphScope>({
            httpMethod: "POST",
            area: "Graph",
            locationId: "21b5fea7-2513-41d0-af78-b8cdb0f328bb",
            resource: "Scopes",
            routeTemplate: "_apis/{area}/{resource}/{scopeDescriptor}",
            requestType: Contracts.TypeInfo.GraphScopeCreationContext,
            responseType: Contracts.TypeInfo.GraphScope,
            routeValues: {
                scopeDescriptor: scopeDescriptor
            },
            apiVersion: this.scopesApiVersion,
            data: creationContext
        });
    }

    /**
     * @internal
     * @exemptedapi
     * [Preview API] Traverse memberships of the given subject descriptor.
     *
     * @param {string} subjectDescriptor - Fetch the descendants/ancestors of this descriptor depending on direction.
     * @param {Contracts.GraphTraversalDirection} direction - The default value is Unknown.
     * @param {number} depth - The default value is '1'.
     * @return IPromise<Contracts.GraphMembershipTraversal>
     */
    public traverseMemberships(
        subjectDescriptor: string,
        direction?: Contracts.GraphTraversalDirection,
        depth?: number
        ): IPromise<Contracts.GraphMembershipTraversal> {

        const queryValues: any = {
            direction: direction,
            depth: depth
        };

        return this._beginRequest<Contracts.GraphMembershipTraversal>({
            httpMethod: "GET",
            area: "Graph",
            locationId: "5d59d874-746f-4f9b-9459-0e571f1ded8c",
            resource: "MembershipTraversals",
            routeTemplate: "_apis/{area}/{resource}/{subjectDescriptor}",
            routeValues: {
                subjectDescriptor: subjectDescriptor
            },
            queryParams: queryValues,
            apiVersion: this.membershipTraversalsApiVersion
        });
    }

    /**
     * @internal
     * @exemptedapi
     * [Preview API] Traverse memberships of the given subject descriptors.
     *
     * @param {Contracts.GraphSubjectLookup} membershipTraversalLookup - Fetch the descendants/ancestors of the list of descriptors depending on direction.
     * @param {Contracts.GraphTraversalDirection} direction - The default value is Unknown.
     * @param {number} depth - The default value is '1'.
     * @return IPromise<{ [key: string] : Contracts.GraphMembershipTraversal; }>
     */
    public lookupMembershipTraversals(
        membershipTraversalLookup: Contracts.GraphSubjectLookup,
        direction?: Contracts.GraphTraversalDirection,
        depth?: number
        ): IPromise<{ [key: string] : Contracts.GraphMembershipTraversal; }> {

        const queryValues: any = {
            direction: direction,
            depth: depth
        };

        return this._beginRequest<{ [key: string] : Contracts.GraphMembershipTraversal; }>({
            httpMethod: "POST",
            area: "Graph",
            locationId: "5d59d874-746f-4f9b-9459-0e571f1ded8c",
            resource: "MembershipTraversals",
            routeTemplate: "_apis/{area}/{resource}/{subjectDescriptor}",
            responseIsCollection: true,
            queryParams: queryValues,
            apiVersion: this.membershipTraversalsApiVersion,
            data: membershipTraversalLookup
        });
    }

    /**
     * @exemptedapi
     * [Preview API] Check whether a subject is active or inactive.
     *
     * @param {string} subjectDescriptor - Descriptor of the subject (user, group, scope, etc.) to check state of
     * @return IPromise<Contracts.GraphMembershipState>
     */
    public getMembershipState(
        subjectDescriptor: string
        ): IPromise<Contracts.GraphMembershipState> {

        return this._beginRequest<Contracts.GraphMembershipState>({
            httpMethod: "GET",
            area: "Graph",
            locationId: "1ffe5c94-1144-4191-907b-d0211cad36a8",
            resource: "MembershipStates",
            routeTemplate: "_apis/{area}/{resource}/{subjectDescriptor}",
            routeValues: {
                subjectDescriptor: subjectDescriptor
            },
            apiVersion: this.membershipStatesApiVersion
        });
    }

    /**
     * @exemptedapi
     * [Preview API] Get all the memberships where this descriptor is a member in the relationship.
     *
     * @param {string} subjectDescriptor - Fetch all direct memberships of this descriptor.
     * @param {Contracts.GraphTraversalDirection} direction - Defaults to Up.
     * @param {number} depth - The maximum number of edges to traverse up or down the membership tree. Currently the only supported value is '1'.
     * @return IPromise<Contracts.GraphMembership[]>
     */
    public listMemberships(
        subjectDescriptor: string,
        direction?: Contracts.GraphTraversalDirection,
        depth?: number
        ): IPromise<Contracts.GraphMembership[]> {

        const queryValues: any = {
            direction: direction,
            depth: depth
        };

        return this._beginRequest<Contracts.GraphMembership[]>({
            httpMethod: "GET",
            area: "Graph",
            locationId: "e34b6394-6b30-4435-94a9-409a5eef3e31",
            resource: "MembershipsBatch",
            routeTemplate: "_apis/{area}/Memberships/{subjectDescriptor}",
            responseIsCollection: true,
            routeValues: {
                subjectDescriptor: subjectDescriptor
            },
            queryParams: queryValues,
            apiVersion: this.membershipsBatchApiVersion
        });
    }

    /**
     * @exemptedapi
     * [Preview API] Deletes a membership between a container and subject.
     *
     * @param {string} subjectDescriptor - A descriptor to a group or user that is the child subject in the relationship.
     * @param {string} containerDescriptor - A descriptor to a group that is the container in the relationship.
     * @return IPromise<void>
     */
    public removeMembership(
        subjectDescriptor: string,
        containerDescriptor: string
        ): IPromise<void> {

        return this._beginRequest<void>({
            httpMethod: "DELETE",
            httpResponseType: "html",
            area: "Graph",
            locationId: "3fd2e6ca-fb30-443a-b579-95b19ed0934c",
            resource: "Memberships",
            routeTemplate: "_apis/{area}/{resource}/{subjectDescriptor}/{containerDescriptor}",
            routeValues: {
                subjectDescriptor: subjectDescriptor,
                containerDescriptor: containerDescriptor
            },
            apiVersion: this.membershipsApiVersion
        });
    }

    /**
     * @exemptedapi
     * [Preview API] Get a membership relationship between a container and subject.
     *
     * @param {string} subjectDescriptor - A descriptor to the child subject in the relationship.
     * @param {string} containerDescriptor - A descriptor to the container in the relationship.
     * @return IPromise<Contracts.GraphMembership>
     */
    public getMembership(
        subjectDescriptor: string,
        containerDescriptor: string
        ): IPromise<Contracts.GraphMembership> {

        return this._beginRequest<Contracts.GraphMembership>({
            httpMethod: "GET",
            area: "Graph",
            locationId: "3fd2e6ca-fb30-443a-b579-95b19ed0934c",
            resource: "Memberships",
            routeTemplate: "_apis/{area}/{resource}/{subjectDescriptor}/{containerDescriptor}",
            routeValues: {
                subjectDescriptor: subjectDescriptor,
                containerDescriptor: containerDescriptor
            },
            apiVersion: this.membershipsApiVersion
        });
    }

    /**
     * @exemptedapi
     * [Preview API] Check to see if a membership relationship between a container and subject exists.
     *
     * @param {string} subjectDescriptor - The group or user that is a child subject of the relationship.
     * @param {string} containerDescriptor - The group that is the container in the relationship.
     * @return IPromise<boolean>
     */
    public checkMembershipExistence(
        subjectDescriptor: string,
        containerDescriptor: string
        ): IPromise<boolean> {

        return this._beginRequest<boolean>({
            httpMethod: "HEAD",
            area: "Graph",
            locationId: "3fd2e6ca-fb30-443a-b579-95b19ed0934c",
            resource: "Memberships",
            routeTemplate: "_apis/{area}/{resource}/{subjectDescriptor}/{containerDescriptor}",
            routeValues: {
                subjectDescriptor: subjectDescriptor,
                containerDescriptor: containerDescriptor
            },
            apiVersion: this.membershipsApiVersion
        }).then(() => {
            return true;
        }, (error) => {
            if (error.status === 404) {
                return false;
            }
            throw error;
        });
    }

    /**
     * @exemptedapi
     * [Preview API] Create a new membership between a container and subject.
     *
     * @param {string} subjectDescriptor - A descriptor to a group or user that can be the child subject in the relationship.
     * @param {string} containerDescriptor - A descriptor to a group that can be the container in the relationship.
     * @return IPromise<Contracts.GraphMembership>
     */
    public addMembership(
        subjectDescriptor: string,
        containerDescriptor: string
        ): IPromise<Contracts.GraphMembership> {

        return this._beginRequest<Contracts.GraphMembership>({
            httpMethod: "PUT",
            area: "Graph",
            locationId: "3fd2e6ca-fb30-443a-b579-95b19ed0934c",
            resource: "Memberships",
            routeTemplate: "_apis/{area}/{resource}/{subjectDescriptor}/{containerDescriptor}",
            routeValues: {
                subjectDescriptor: subjectDescriptor,
                containerDescriptor: containerDescriptor
            },
            apiVersion: this.membershipsApiVersion
        });
    }

    /**
     * @internal
     * @exemptedapi
     * [Preview API] This endpoint returns a result for any member that has ever been valid in the system, even if the member has since been deleted or has had all their memberships deleted. The current validity of the member is indicated through its disabled property, which is omitted when false.
     *
     * @param {string} memberDescriptor - The descriptor of the desired member.
     * @return IPromise<Contracts.GraphMember>
     */
    public getMemberByDescriptor(
        memberDescriptor: string
        ): IPromise<Contracts.GraphMember> {

        return this._beginRequest<Contracts.GraphMember>({
            httpMethod: "GET",
            area: "Graph",
            locationId: "b9af63a7-5db6-4af8-aae7-387f775ea9c6",
            resource: "Members",
            routeTemplate: "_apis/{area}/{resource}/{memberDescriptor}",
            routeValues: {
                memberDescriptor: memberDescriptor
            },
            apiVersion: this.membersApiVersion
        });
    }

    /**
     * @internal
     * @exemptedapi
     * [Preview API] Gets all requested members in the current scope (usually organization or account).
     *
     * @param {Contracts.GraphSubjectLookup} memberLookup
     * @return IPromise<{ [key: string] : Contracts.GraphMember; }>
     */
    public lookupMembers(
        memberLookup: Contracts.GraphSubjectLookup
        ): IPromise<{ [key: string] : Contracts.GraphMember; }> {

        return this._beginRequest<{ [key: string] : Contracts.GraphMember; }>({
            httpMethod: "POST",
            area: "Graph",
            locationId: "3d74d524-ae3d-4d24-a9a7-f8a5cf82347a",
            resource: "MemberLookup",
            routeTemplate: "_apis/{area}/{resource}",
            responseIsCollection: true,
            apiVersion: this.memberLookupApiVersion,
            data: memberLookup
        });
    }

    /**
     * @exemptedapi
     * [Preview API] Update the properties of an Azure DevOps group.
     *
     * @param {string} groupDescriptor - The descriptor of the group to modify.
     * @param {VSS_Common_Contracts.JsonPatchDocument} patchDocument - The JSON+Patch document containing the fields to alter.
     * @return IPromise<Contracts.GraphGroup>
     */
    public updateGroup(
        groupDescriptor: string,
        patchDocument: VSS_Common_Contracts.JsonPatchDocument
        ): IPromise<Contracts.GraphGroup> {

        return this._beginRequest<Contracts.GraphGroup>({
            httpMethod: "PATCH",
            area: "Graph",
            locationId: "ebbe6af8-0b91-4c13-8cf1-777c14858188",
            resource: "Groups",
            routeTemplate: "_apis/{area}/{resource}/{groupDescriptor}",
            routeValues: {
                groupDescriptor: groupDescriptor
            },
            customHeaders: {
                "Content-Type": "application/json-patch+json",
            },
            apiVersion: this.groupsApiVersion,
            data: patchDocument
        });
    }

    /**
     * @exemptedapi
     * [Preview API] Gets a list of all groups in the current scope (usually organization or account).
     *
     * @param {string} scopeDescriptor - Specify a non-default scope (collection, project) to search for groups.
     * @param {string[]} subjectTypes - A comma separated list of user subject subtypes to reduce the retrieved results, e.g. Microsoft.IdentityModel.Claims.ClaimsIdentity
     * @param {string} continuationToken - An opaque data blob that allows the next page of data to resume immediately after where the previous page ended. The only reliable way to know if there is more data left is the presence of a continuation token.
     * @return IPromise<Contracts.PagedGraphGroups>
     */
    public listGroups(
        scopeDescriptor?: string,
        subjectTypes?: string[],
        continuationToken?: string
        ): IPromise<Contracts.PagedGraphGroups> {

        const queryValues: any = {
            scopeDescriptor: scopeDescriptor,
            subjectTypes: subjectTypes && subjectTypes.join(","),
            continuationToken: continuationToken
        };

        return this._beginRequest<[any, string, JQueryXHR]>({
            httpMethod: "GET",
            area: "Graph",
            locationId: "ebbe6af8-0b91-4c13-8cf1-777c14858188",
            resource: "Groups",
            routeTemplate: "_apis/{area}/{resource}/{groupDescriptor}",
            responseIsCollection: true,
            queryParams: queryValues,
            apiVersion: this.groupsApiVersion
        }, true).then(([data, textStatus, jqXHR]) => {
            const continuationTokenHeader = jqXHR.getResponseHeader("X-MS-ContinuationToken");
            return {
                graphGroups: data,
                continuationToken: continuationTokenHeader ? continuationTokenHeader.split(',') : []
            };
        });
    }

    /**
     * @exemptedapi
     * [Preview API] Get a group by its descriptor.
     *
     * @param {string} groupDescriptor - The descriptor of the desired graph group.
     * @return IPromise<Contracts.GraphGroup>
     */
    public getGroup(
        groupDescriptor: string
        ): IPromise<Contracts.GraphGroup> {

        return this._beginRequest<Contracts.GraphGroup>({
            httpMethod: "GET",
            area: "Graph",
            locationId: "ebbe6af8-0b91-4c13-8cf1-777c14858188",
            resource: "Groups",
            routeTemplate: "_apis/{area}/{resource}/{groupDescriptor}",
            routeValues: {
                groupDescriptor: groupDescriptor
            },
            apiVersion: this.groupsApiVersion
        });
    }

    /**
     * @exemptedapi
     * [Preview API] Removes an Azure DevOps group from all of its parent groups.
     *
     * @param {string} groupDescriptor - The descriptor of the group to delete.
     * @return IPromise<void>
     */
    public deleteGroup(
        groupDescriptor: string
        ): IPromise<void> {

        return this._beginRequest<void>({
            httpMethod: "DELETE",
            httpResponseType: "html",
            area: "Graph",
            locationId: "ebbe6af8-0b91-4c13-8cf1-777c14858188",
            resource: "Groups",
            routeTemplate: "_apis/{area}/{resource}/{groupDescriptor}",
            routeValues: {
                groupDescriptor: groupDescriptor
            },
            apiVersion: this.groupsApiVersion
        });
    }

    /**
     * @exemptedapi
     * [Preview API] Create a new Azure DevOps group or materialize an existing AAD group.
     *
     * @param {Contracts.GraphGroupCreationContext} creationContext - The subset of the full graph group used to uniquely find the graph subject in an external provider.
     * @param {string} scopeDescriptor - A descriptor referencing the scope (collection, project) in which the group should be created. If omitted, will be created in the scope of the enclosing account or organization. Valid only for VSTS groups.
     * @param {string[]} groupDescriptors - A comma separated list of descriptors referencing groups you want the graph group to join
     * @return IPromise<Contracts.GraphGroup>
     */
    public createGroup(
        creationContext: Contracts.GraphGroupCreationContext,
        scopeDescriptor?: string,
        groupDescriptors?: string[]
        ): IPromise<Contracts.GraphGroup> {

        const queryValues: any = {
            scopeDescriptor: scopeDescriptor,
            groupDescriptors: groupDescriptors && groupDescriptors.join(",")
        };

        return this._beginRequest<Contracts.GraphGroup>({
            httpMethod: "POST",
            area: "Graph",
            locationId: "ebbe6af8-0b91-4c13-8cf1-777c14858188",
            resource: "Groups",
            routeTemplate: "_apis/{area}/{resource}/{groupDescriptor}",
            queryParams: queryValues,
            apiVersion: this.groupsApiVersion,
            data: creationContext
        });
    }

    /**
     * @internal
     * @exemptedapi
     * [Preview API]
     *
     * @return IPromise<Contracts.GraphCachePolicies>
     */
    public getCachePolicies(): IPromise<Contracts.GraphCachePolicies> {

        return this._beginRequest<Contracts.GraphCachePolicies>({
            httpMethod: "GET",
            area: "Graph",
            locationId: "beb83272-b415-48e8-ac1e-a9b805760739",
            resource: "CachePolicies",
            routeTemplate: "_apis/{area}/{resource}",
            apiVersion: this.cachePoliciesApiVersion
        });
    }
}

export class CommonMethods4To7_2 extends CommonMethods3_2To7_2 {
    protected providerInfoApiVersion: string;

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }

    /**
     * @param {string} userDescriptor
     * @return IPromise<Contracts.GraphProviderInfo>
     */
    public getProviderInfo(
        userDescriptor: string
        ): IPromise<Contracts.GraphProviderInfo> {

        return this._beginRequest<Contracts.GraphProviderInfo>({
            httpMethod: "GET",
            area: "Graph",
            locationId: "1e377995-6fa2-4588-bd64-930186abdcfa",
            resource: "ProviderInfo",
            routeTemplate: "_apis/{area}/Users/{userDescriptor}/{resource}",
            routeValues: {
                userDescriptor: userDescriptor
            },
            apiVersion: this.providerInfoApiVersion
        });
    }
}

export class CommonMethods5To7_2 extends CommonMethods4To7_2 {
    protected federatedProviderDataApiVersion: string;

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }

    /**
     * @internal
     * [Preview API] Acquires the full set of federated provider authentication data available for the given graph subject and provider name.
     *
     * @param {string} subjectDescriptor - the descriptor of the graph subject that we should acquire data for
     * @param {string} providerName - the name of the provider to acquire data for, e.g. "github.com"
     * @param {number} versionHint - a version hint that can be used for optimistic cache concurrency and to support retries on access token failures; note that this is a hint only and does not guarantee a particular version on the response
     * @return IPromise<Contracts.GraphFederatedProviderData>
     */
    public getFederatedProviderData(
        subjectDescriptor: string,
        providerName: string,
        versionHint?: number
        ): IPromise<Contracts.GraphFederatedProviderData> {

        const queryValues: any = {
            providerName: providerName,
            versionHint: versionHint
        };

        return this._beginRequest<Contracts.GraphFederatedProviderData>({
            httpMethod: "GET",
            area: "Graph",
            locationId: "5dcd28d6-632d-477f-ac6b-398ea9fc2f71",
            resource: "FederatedProviderData",
            routeTemplate: "_apis/{area}/{resource}/{subjectDescriptor}",
            routeValues: {
                subjectDescriptor: subjectDescriptor
            },
            queryParams: queryValues,
            apiVersion: this.federatedProviderDataApiVersion
        });
    }
}

export class CommonMethods5_1To7_2 extends CommonMethods5To7_2 {
    protected avatarsApiVersion: string;
    protected requestAccessApiVersion: string;
    protected subjectQueryApiVersion: string;

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }

    /**
     * @exemptedapi
     * [Preview API] Search for Azure Devops users, or/and groups. Results will be returned in a batch with no more than 100 graph subjects.
     *
     * @param {Contracts.GraphSubjectQuery} subjectQuery - The query that we'll be using to search includes the following: Query: the search term. The search will be prefix matching only. SubjectKind: "User" or "Group" can be specified, both or either ScopeDescriptor: Non-default scope can be specified, i.e. project scope descriptor
     * @return IPromise<Contracts.GraphSubject[]>
     */
    public querySubjects(
        subjectQuery: Contracts.GraphSubjectQuery
        ): IPromise<Contracts.GraphSubject[]> {

        return this._beginRequest<Contracts.GraphSubject[]>({
            httpMethod: "POST",
            area: "Graph",
            locationId: "05942c89-006a-48ce-bb79-baeb8abf99c6",
            resource: "SubjectQuery",
            routeTemplate: "_apis/{area}/{resource}",
            responseIsCollection: true,
            apiVersion: this.subjectQueryApiVersion,
            data: subjectQuery
        });
    }

    /**
     * @exemptedapi
     * [Preview API]
     *
     * @param {any} jsondocument
     * @return IPromise<void>
     */
    public requestAccess(
        jsondocument: any
        ): IPromise<void> {

        return this._beginRequest<void>({
            httpMethod: "POST",
            httpResponseType: "html",
            area: "Graph",
            locationId: "8d54bf92-8c99-47f2-9972-b21341f1722e",
            resource: "RequestAccess",
            routeTemplate: "_apis/{area}/{resource}",
            apiVersion: this.requestAccessApiVersion,
            data: jsondocument
        });
    }

    /**
     * @param {VSS_Profile_Contracts.Avatar} avatar
     * @param {string} subjectDescriptor
     * @return IPromise<void>
     */
    public setAvatar(
        avatar: VSS_Profile_Contracts.Avatar,
        subjectDescriptor: string
        ): IPromise<void> {

        return this._beginRequest<void>({
            httpMethod: "PUT",
            httpResponseType: "html",
            area: "Graph",
            locationId: "801eaf9c-0585-4be8-9cdb-b0efa074de91",
            resource: "Avatars",
            routeTemplate: "_apis/{area}/Subjects/{subjectDescriptor}/{resource}",
            requestType: VSS_Profile_Contracts.TypeInfo.Avatar,
            routeValues: {
                subjectDescriptor: subjectDescriptor
            },
            apiVersion: this.avatarsApiVersion,
            data: avatar
        });
    }

    /**
     * @param {string} subjectDescriptor
     * @param {VSS_Profile_Contracts.AvatarSize} size
     * @param {string} format
     * @return IPromise<VSS_Profile_Contracts.Avatar>
     */
    public getAvatar(
        subjectDescriptor: string,
        size?: VSS_Profile_Contracts.AvatarSize,
        format?: string
        ): IPromise<VSS_Profile_Contracts.Avatar> {

        const queryValues: any = {
            size: size,
            format: format
        };

        return this._beginRequest<VSS_Profile_Contracts.Avatar>({
            httpMethod: "GET",
            area: "Graph",
            locationId: "801eaf9c-0585-4be8-9cdb-b0efa074de91",
            resource: "Avatars",
            routeTemplate: "_apis/{area}/Subjects/{subjectDescriptor}/{resource}",
            responseType: VSS_Profile_Contracts.TypeInfo.Avatar,
            routeValues: {
                subjectDescriptor: subjectDescriptor
            },
            queryParams: queryValues,
            apiVersion: this.avatarsApiVersion
        });
    }

    /**
     * @param {string} subjectDescriptor
     * @return IPromise<void>
     */
    public deleteAvatar(
        subjectDescriptor: string
        ): IPromise<void> {

        return this._beginRequest<void>({
            httpMethod: "DELETE",
            httpResponseType: "html",
            area: "Graph",
            locationId: "801eaf9c-0585-4be8-9cdb-b0efa074de91",
            resource: "Avatars",
            routeTemplate: "_apis/{area}/Subjects/{subjectDescriptor}/{resource}",
            routeValues: {
                subjectDescriptor: subjectDescriptor
            },
            apiVersion: this.avatarsApiVersion
        });
    }
}

export class CommonMethods6To7_2 extends CommonMethods5_1To7_2 {
    protected identityTranslationApiVersion: string;

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }

    /**
     * @internal
     * [Preview API] Identity Translation - Translate endpoint is supposed to be used by geneva action.
     *
     * @param {string} masterId
     * @param {string} localId
     * @return IPromise<string>
     */
    public translate(
        masterId?: string,
        localId?: string
        ): IPromise<string> {

        const queryValues: any = {
            masterId: masterId,
            localId: localId
        };

        return this._beginRequest<string>({
            httpMethod: "GET",
            area: "Graph",
            locationId: "9cacc4da-06e3-474a-a1fa-604dd34a2fa2",
            resource: "IdentityTranslation",
            routeTemplate: "_apis/{area}/{resource}",
            queryParams: queryValues,
            apiVersion: this.identityTranslationApiVersion
        });
    }
}

export class CommonMethods7_1To7_2 extends CommonMethods6To7_2 {
    protected membersApiVersion_8b9ecdb2: string;
    protected resolveDisconnectedUsersApiVersion: string;
    protected servicePrincipalsApiVersion: string;

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }

    /**
     * @internal
     * [Preview API] Map an existing service principal to a different service principal.
     *
     * @param {Contracts.GraphServicePrincipalUpdateContext} updateContext - The subset of the full graph service principal used to uniquely find the graph subject in an external provider.
     * @param {string} servicePrincipalDescriptor - The descriptor of the service principal to update
     * @return IPromise<Contracts.GraphServicePrincipal>
     */
    public updateServicePrincipal(
        updateContext: Contracts.GraphServicePrincipalUpdateContext,
        servicePrincipalDescriptor: string
        ): IPromise<Contracts.GraphServicePrincipal> {

        return this._beginRequest<Contracts.GraphServicePrincipal>({
            httpMethod: "PATCH",
            area: "Graph",
            locationId: "e1dbb0ae-49cb-4532-95a1-86cd89cfcab4",
            resource: "ServicePrincipals",
            routeTemplate: "_apis/{area}/{resource}/{servicePrincipalDescriptor}",
            responseType: Contracts.TypeInfo.GraphServicePrincipal,
            routeValues: {
                servicePrincipalDescriptor: servicePrincipalDescriptor
            },
            apiVersion: this.servicePrincipalsApiVersion,
            data: updateContext
        });
    }

    /**
     * [Preview API] Get a list of all service principals in a given scope.
     *
     * @param {string} continuationToken - An opaque data blob that allows the next page of data to resume immediately after where the previous page ended. The only reliable way to know if there is more data left is the presence of a continuation token.
     * @param {string} scopeDescriptor - Specify a non-default scope (collection, project) to search for service principals.
     * @return IPromise<Contracts.PagedGraphServicePrincipals>
     */
    public listServicePrincipals(
        continuationToken?: string,
        scopeDescriptor?: string
        ): IPromise<Contracts.PagedGraphServicePrincipals> {

        const queryValues: any = {
            continuationToken: continuationToken,
            scopeDescriptor: scopeDescriptor
        };

        return this._beginRequest<[any, string, JQueryXHR]>({
            httpMethod: "GET",
            area: "Graph",
            locationId: "e1dbb0ae-49cb-4532-95a1-86cd89cfcab4",
            resource: "ServicePrincipals",
            routeTemplate: "_apis/{area}/{resource}/{servicePrincipalDescriptor}",
            responseType: Contracts.TypeInfo.GraphServicePrincipal,
            responseIsCollection: true,
            queryParams: queryValues,
            apiVersion: this.servicePrincipalsApiVersion
        }, true).then(([data, textStatus, jqXHR]) => {
            const continuationTokenHeader = jqXHR.getResponseHeader("X-MS-ContinuationToken");
            return {
                graphServicePrincipals: data,
                continuationToken: continuationTokenHeader ? continuationTokenHeader.split(',') : []
            };
        });
    }

    /**
     * [Preview API] Get a service principal by its descriptor.
     *
     * @param {string} servicePrincipalDescriptor - The descriptor of the desired service principal.
     * @return IPromise<Contracts.GraphServicePrincipal>
     */
    public getServicePrincipal(
        servicePrincipalDescriptor: string
        ): IPromise<Contracts.GraphServicePrincipal> {

        return this._beginRequest<Contracts.GraphServicePrincipal>({
            httpMethod: "GET",
            area: "Graph",
            locationId: "e1dbb0ae-49cb-4532-95a1-86cd89cfcab4",
            resource: "ServicePrincipals",
            routeTemplate: "_apis/{area}/{resource}/{servicePrincipalDescriptor}",
            responseType: Contracts.TypeInfo.GraphServicePrincipal,
            routeValues: {
                servicePrincipalDescriptor: servicePrincipalDescriptor
            },
            apiVersion: this.servicePrincipalsApiVersion
        });
    }

    /**
     * [Preview API] Disables a service principal.
     *
     * @param {string} servicePrincipalDescriptor - The descriptor of the service principal to delete.
     * @return IPromise<void>
     */
    public deleteServicePrincipal(
        servicePrincipalDescriptor: string
        ): IPromise<void> {

        return this._beginRequest<void>({
            httpMethod: "DELETE",
            httpResponseType: "html",
            area: "Graph",
            locationId: "e1dbb0ae-49cb-4532-95a1-86cd89cfcab4",
            resource: "ServicePrincipals",
            routeTemplate: "_apis/{area}/{resource}/{servicePrincipalDescriptor}",
            routeValues: {
                servicePrincipalDescriptor: servicePrincipalDescriptor
            },
            apiVersion: this.servicePrincipalsApiVersion
        });
    }

    /**
     * [Preview API] Materialize an existing AAD service principal into the ADO account.
     *
     * @param {Contracts.GraphServicePrincipalCreationContext} creationContext - The subset of the full graph service principal used to uniquely find the graph subject in an external provider.
     * @param {string[]} groupDescriptors - A comma separated list of descriptors of groups you want the graph service principal to join
     * @return IPromise<Contracts.GraphServicePrincipal>
     */
    public createServicePrincipal(
        creationContext: Contracts.GraphServicePrincipalCreationContext,
        groupDescriptors?: string[]
        ): IPromise<Contracts.GraphServicePrincipal> {

        const queryValues: any = {
            groupDescriptors: groupDescriptors && groupDescriptors.join(",")
        };

        return this._beginRequest<Contracts.GraphServicePrincipal>({
            httpMethod: "POST",
            area: "Graph",
            locationId: "e1dbb0ae-49cb-4532-95a1-86cd89cfcab4",
            resource: "ServicePrincipals",
            routeTemplate: "_apis/{area}/{resource}/{servicePrincipalDescriptor}",
            responseType: Contracts.TypeInfo.GraphServicePrincipal,
            queryParams: queryValues,
            apiVersion: this.servicePrincipalsApiVersion,
            data: creationContext
        });
    }

    /**
     * @internal
     * [Preview API] Batch-map a list of users to new users.
     *
     * @param {Contracts.IdentityMappings} mappings - A list of mappings.
     * @return IPromise<Contracts.ResolveDisconnectedUsersResponse>
     */
    public resolve(
        mappings: Contracts.IdentityMappings
        ): IPromise<Contracts.ResolveDisconnectedUsersResponse> {

        return this._beginRequest<Contracts.ResolveDisconnectedUsersResponse>({
            httpMethod: "POST",
            area: "Graph",
            locationId: "2f0cae3a-74a3-4c40-a13b-974889698e6b",
            resource: "ResolveDisconnectedUsers",
            routeTemplate: "_apis/{area}/{resource}",
            apiVersion: this.resolveDisconnectedUsersApiVersion,
            data: mappings
        });
    }

    /**
     * @internal
     * [Preview API] Get a list of all members in a given scope.
     *
     * @param {string} continuationToken - An opaque data blob that allows the next page of data to resume immediately after where the previous page ended. The only reliable way to know if there is more data left is the presence of a continuation token.
     * @param {string[]} subjectTypes - A comma separated list of user subject subtypes to reduce the retrieved results, e.g. ‘msa’, ‘aad’, ‘svc’ (service identity), ‘imp’ (imported identity), etc.
     * @param {string[]} subjectKinds - A comma sepearted list of user subject subjectkinds to reduce the retrieved results, e.g. ‘user’, ‘servicePrincipal’
     * @param {string[]} metaTypes
     * @param {string} scopeDescriptor - Specify a non-default scope (collection, project) to search for users.
     * @return IPromise<Contracts.PagedGraphMembers>
     */
    public listMembers(
        continuationToken?: string,
        subjectTypes?: string[],
        subjectKinds?: string[],
        metaTypes?: string[],
        scopeDescriptor?: string
        ): IPromise<Contracts.PagedGraphMembers> {

        const queryValues: any = {
            continuationToken: continuationToken,
            subjectTypes: subjectTypes && subjectTypes.join(","),
            subjectKinds: subjectKinds && subjectKinds.join(","),
            metaTypes: metaTypes && metaTypes.join(","),
            scopeDescriptor: scopeDescriptor
        };

        return this._beginRequest<[any, string, JQueryXHR]>({
            httpMethod: "GET",
            area: "Graph",
            locationId: "8b9ecdb2-b752-485a-8418-cc15cf12ee07",
            resource: "Members",
            routeTemplate: "_apis/{area}/{resource}",
            responseIsCollection: true,
            queryParams: queryValues,
            apiVersion: this.membersApiVersion_8b9ecdb2
        }, true).then(([data, textStatus, jqXHR]) => {
            const continuationTokenHeader = jqXHR.getResponseHeader("X-MS-ContinuationToken");
            return {
                graphMembers: data,
                continuationToken: continuationTokenHeader ? continuationTokenHeader.split(',') : []
            };
        });
    }
}

/**
 * @exemptedapi
 */
export class GraphHttpClient7_2 extends CommonMethods7_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.avatarsApiVersion =
        this.cachePoliciesApiVersion =
        this.descriptorsApiVersion =
        this.federatedProviderDataApiVersion =
        this.groupsApiVersion =
        this.identityTranslationApiVersion =
        this.memberLookupApiVersion =
        this.membershipsApiVersion =
        this.membershipsBatchApiVersion =
        this.membershipStatesApiVersion =
        this.membershipTraversalsApiVersion =
        this.providerInfoApiVersion =
        this.requestAccessApiVersion =
        this.resolveDisconnectedUsersApiVersion =
        this.scopesApiVersion =
        this.servicePrincipalsApiVersion =
        this.storageKeysApiVersion =
        this.subjectLookupApiVersion =
        this.subjectQueryApiVersion =
        this.subjectsApiVersion =
        this.usersApiVersion = "7.2-preview.1";
        this.membersApiVersion =
        this.membersApiVersion_8b9ecdb2 = "7.2-preview.2";
    }
}

/**
 * @exemptedapi
 */
export class GraphHttpClient7_1 extends CommonMethods7_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.avatarsApiVersion =
        this.descriptorsApiVersion =
        this.providerInfoApiVersion =
        this.storageKeysApiVersion = "7.1";
        this.cachePoliciesApiVersion =
        this.federatedProviderDataApiVersion =
        this.groupsApiVersion =
        this.identityTranslationApiVersion =
        this.memberLookupApiVersion =
        this.membershipsApiVersion =
        this.membershipsBatchApiVersion =
        this.membershipStatesApiVersion =
        this.membershipTraversalsApiVersion =
        this.requestAccessApiVersion =
        this.resolveDisconnectedUsersApiVersion =
        this.scopesApiVersion =
        this.servicePrincipalsApiVersion =
        this.subjectLookupApiVersion =
        this.subjectQueryApiVersion =
        this.subjectsApiVersion =
        this.usersApiVersion = "7.1-preview.1";
        this.membersApiVersion =
        this.membersApiVersion_8b9ecdb2 = "7.1-preview.2";
    }
}

/**
 * @exemptedapi
 */
export class GraphHttpClient7 extends CommonMethods6To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.avatarsApiVersion =
        this.descriptorsApiVersion =
        this.providerInfoApiVersion =
        this.storageKeysApiVersion = "7.0";
        this.cachePoliciesApiVersion =
        this.federatedProviderDataApiVersion =
        this.groupsApiVersion =
        this.identityTranslationApiVersion =
        this.memberLookupApiVersion =
        this.membersApiVersion =
        this.membershipsApiVersion =
        this.membershipsBatchApiVersion =
        this.membershipStatesApiVersion =
        this.membershipTraversalsApiVersion =
        this.requestAccessApiVersion =
        this.scopesApiVersion =
        this.subjectLookupApiVersion =
        this.subjectQueryApiVersion =
        this.subjectsApiVersion =
        this.usersApiVersion = "7.0-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class GraphHttpClient6_1 extends CommonMethods6To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.avatarsApiVersion =
        this.descriptorsApiVersion =
        this.providerInfoApiVersion =
        this.storageKeysApiVersion = "6.1";
        this.cachePoliciesApiVersion =
        this.federatedProviderDataApiVersion =
        this.groupsApiVersion =
        this.identityTranslationApiVersion =
        this.memberLookupApiVersion =
        this.membersApiVersion =
        this.membershipsApiVersion =
        this.membershipsBatchApiVersion =
        this.membershipStatesApiVersion =
        this.membershipTraversalsApiVersion =
        this.requestAccessApiVersion =
        this.scopesApiVersion =
        this.subjectLookupApiVersion =
        this.subjectQueryApiVersion =
        this.subjectsApiVersion =
        this.usersApiVersion = "6.1-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class GraphHttpClient6 extends CommonMethods6To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.avatarsApiVersion =
        this.descriptorsApiVersion =
        this.providerInfoApiVersion =
        this.storageKeysApiVersion = "6.0";
        this.cachePoliciesApiVersion =
        this.federatedProviderDataApiVersion =
        this.groupsApiVersion =
        this.identityTranslationApiVersion =
        this.memberLookupApiVersion =
        this.membersApiVersion =
        this.membershipsApiVersion =
        this.membershipsBatchApiVersion =
        this.membershipStatesApiVersion =
        this.membershipTraversalsApiVersion =
        this.requestAccessApiVersion =
        this.scopesApiVersion =
        this.subjectLookupApiVersion =
        this.subjectQueryApiVersion =
        this.subjectsApiVersion =
        this.usersApiVersion = "6.0-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class GraphHttpClient5_2 extends CommonMethods5_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.avatarsApiVersion =
        this.descriptorsApiVersion =
        this.providerInfoApiVersion =
        this.storageKeysApiVersion = "5.2";
        this.cachePoliciesApiVersion =
        this.federatedProviderDataApiVersion =
        this.groupsApiVersion =
        this.memberLookupApiVersion =
        this.membersApiVersion =
        this.membershipsApiVersion =
        this.membershipsBatchApiVersion =
        this.membershipStatesApiVersion =
        this.membershipTraversalsApiVersion =
        this.requestAccessApiVersion =
        this.scopesApiVersion =
        this.subjectLookupApiVersion =
        this.subjectQueryApiVersion =
        this.subjectsApiVersion =
        this.usersApiVersion = "5.2-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class GraphHttpClient5_1 extends CommonMethods5_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.avatarsApiVersion =
        this.descriptorsApiVersion =
        this.providerInfoApiVersion =
        this.storageKeysApiVersion = "5.1";
        this.cachePoliciesApiVersion =
        this.federatedProviderDataApiVersion =
        this.groupsApiVersion =
        this.memberLookupApiVersion =
        this.membersApiVersion =
        this.membershipsApiVersion =
        this.membershipsBatchApiVersion =
        this.membershipStatesApiVersion =
        this.membershipTraversalsApiVersion =
        this.requestAccessApiVersion =
        this.scopesApiVersion =
        this.subjectLookupApiVersion =
        this.subjectQueryApiVersion =
        this.subjectsApiVersion =
        this.usersApiVersion = "5.1-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class GraphHttpClient5 extends CommonMethods5To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.descriptorsApiVersion =
        this.providerInfoApiVersion =
        this.storageKeysApiVersion = "5.0";
        this.cachePoliciesApiVersion =
        this.federatedProviderDataApiVersion =
        this.groupsApiVersion =
        this.memberLookupApiVersion =
        this.membersApiVersion =
        this.membershipsApiVersion =
        this.membershipsBatchApiVersion =
        this.membershipStatesApiVersion =
        this.membershipTraversalsApiVersion =
        this.scopesApiVersion =
        this.subjectLookupApiVersion =
        this.subjectsApiVersion =
        this.usersApiVersion = "5.0-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class GraphHttpClient4_1 extends CommonMethods4To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.descriptorsApiVersion =
        this.providerInfoApiVersion =
        this.storageKeysApiVersion = "4.1";
        this.cachePoliciesApiVersion =
        this.groupsApiVersion =
        this.memberLookupApiVersion =
        this.membersApiVersion =
        this.membershipsApiVersion =
        this.membershipsBatchApiVersion =
        this.membershipStatesApiVersion =
        this.membershipTraversalsApiVersion =
        this.scopesApiVersion =
        this.subjectLookupApiVersion =
        this.subjectsApiVersion =
        this.usersApiVersion = "4.1-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class GraphHttpClient4 extends CommonMethods4To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.descriptorsApiVersion =
        this.providerInfoApiVersion =
        this.storageKeysApiVersion = "4.0";
        this.cachePoliciesApiVersion =
        this.groupsApiVersion =
        this.memberLookupApiVersion =
        this.membersApiVersion =
        this.membershipsApiVersion =
        this.membershipsBatchApiVersion =
        this.membershipStatesApiVersion =
        this.membershipTraversalsApiVersion =
        this.scopesApiVersion =
        this.subjectLookupApiVersion =
        this.subjectsApiVersion =
        this.usersApiVersion = "4.0-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class GraphHttpClient3_2 extends CommonMethods3_2To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.descriptorsApiVersion =
        this.storageKeysApiVersion = "3.2";
        this.cachePoliciesApiVersion =
        this.groupsApiVersion =
        this.memberLookupApiVersion =
        this.membersApiVersion =
        this.membershipsApiVersion =
        this.membershipsBatchApiVersion =
        this.membershipStatesApiVersion =
        this.membershipTraversalsApiVersion =
        this.scopesApiVersion =
        this.subjectLookupApiVersion =
        this.subjectsApiVersion =
        this.usersApiVersion = "3.2-preview.1";
    }
}

/**
 * @exemptedapi
 */
export class GraphHttpClient3_1 extends CommonMethods3_1To7_2 {

    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
        this.descriptorsApiVersion = "3.1";
    }
}

export class GraphHttpClient extends GraphHttpClient7_2 {
    constructor(rootRequestPath: string, options?: VSS_WebApi.IVssHttpClientOptions) {
        super(rootRequestPath, options);
    }
}

const clientMapping: { [id: string]: new (routeRequestPath: string) => VSS_WebApi.VssHttpClient; } = {
    "7.2": GraphHttpClient7_2,
    "7.1": GraphHttpClient7_1,
    "7.0": GraphHttpClient7,
    "6.1": GraphHttpClient6_1,
    "6.0": GraphHttpClient6,
    "5.2": GraphHttpClient5_2,
    "5.1": GraphHttpClient5_1,
    "5.0": GraphHttpClient5,
    "4.1": GraphHttpClient4_1,
    "4.0": GraphHttpClient4,
    "3.2": GraphHttpClient3_2,
    "3.1": GraphHttpClient3_1
}

/**
 * Gets an http client targeting the latest released version of the APIs.
 *
 * @return GraphHttpClient7_1
 */
export function getClient(options?: VSS_WebApi.IVssHttpClientOptions): GraphHttpClient7_1 {
    if ((<any>window).VSS && (<any>window).VSS.VssSDKRestVersion && clientMapping[(<any>window).VSS.VssSDKRestVersion]) {
        return VSS_Service.getClient<GraphHttpClient7_1>(<any>(clientMapping[(<any>window).VSS.VssSDKRestVersion]), undefined, undefined, undefined, options);
    }
    else {
        return VSS_Service.getClient<GraphHttpClient7_1>(GraphHttpClient7_1, undefined, undefined, undefined, options);
    }
}
